import React from "react";
import "bootstrap/dist/css/bootstrap.css";

const Header = () => {
  return (
    <nav className="navbar navbar-head navbar-light ">
      <a className="navbar-brand ml-5" href="#justForDebugging">
        Where To Travel?
      </a>
    </nav>
  );
};

export default Header;
